import { Text } from 'app/design/primitives/text';
import type { Listing } from 'app/types/listing';

export function MessageSectionOthersListings({ numInteractions }: Pick<Listing, 'numInteractions'>) {
  if (!Number.isInteger(numInteractions)) {
    return null;
  }
  const emoji = '💬'; // 👤 This emoji is a candidate emoji if the comments use 💭 to avoid similarity
  return (
    <Text fontWeight="600" textAlign="center" variant="bodyBase">
      {emoji} {numInteractions}
    </Text>
  );
}
